/*! personalization-sevice.js */
import Resources from "build/resources";
import Log from "app/utils/log";
import ErrorReport from "app/utils/error-report";
import PersonalizationClient from "ms.personalization";
import Cookies from "app/utils/cookies";

const log = new Log("PersonalizationService");

const RECOMMENDER = "cfru";

const EXP_PREF = "exp_pref";

const DEFAULT_OPTIONS = {
    backfillFacets: "Video|All",
    decayCoefficient: 1,
    inactivePeriod: 2592000000,
    limit: 10,
    maxAge: 604800000,
    rescorers: "random;tpx",
    "rescorers.tpx.minimumScore": 0.1,
    "rescorers.random.minimumScore": 0.1,
    resourceTypes: "Video",
    thumbnailRequired: true
};

const DEFAULT_USER_OPTIONS = {
    "autoplay": true,
    "techOrder": ["html5"]
};

/**
 * @class PersonalizationService
 */
class PersonalizationService {
    /**
     * @constructs PersonalizationService
     * @param {object} config Allows overwrite of default endpoint options
     */
    constructor(config = {}) {
        this.client = new PersonalizationClient({
            url: Resources.PERSONALIZATION_API
        });

        this.options = Object.assign({}, DEFAULT_OPTIONS, config);

        const expPref = Cookies.get(EXP_PREF);
        if (expPref) {
            this.options[EXP_PREF] = expPref;
        }
    }

    /**
     * @method
     * @param {object} requestOptions
     * @param {object} itemProperties
     * @return {Promise.<Array>}
     */
    getRecommendations(requestOptions = {}, itemProperties = {}) {
        const search = Object.assign({}, this.options, requestOptions);
        return this.client.getRecommended(RECOMMENDER, search)
            .then(recommendations => PersonalizationService.formatRecommendations(recommendations, itemProperties))
            .catch(reason => ErrorReport.recordGenericError(log, "Error fetching personalization data:", reason));
    }

    /**
     * @static
     * @param {Array} recommendations
     * @param {object} options
     * @return {Array}
     */
    static formatRecommendations(recommendations, options = DEFAULT_USER_OPTIONS) {
        return recommendations.map(item => {
            return Object.assign({}, options, {
                title: item.headline,
                poster: item.thumbnailUrl,
                id: item.assetID,
                idType: "BMMR",
                "share_metadata": {
                    "canonical_url": item.url
                }
            });
        });
    }
}

export default PersonalizationService;
